<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditSetorDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <SetorDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:remove="remover"
                             :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import SetorDataTable from "../../components/shared/datatables/SetorDataTable";
import BaseView from "../BaseView";
import {findOne,remove} from "../../api/setor";
import CreateEditSetorDialog from "../../components/shared/dialogs/CreateEditSetorDialog";
import {ApiError} from "../../api/core";
import {mapGetters} from "vuex";

export default {
  name: "index",
  components: {CreateEditSetorDialog, BaseView, SetorDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Descrição',
          column: 'descricao',
          type: 'text'
        }
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },
  methods: {
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {};
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Setor. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Setor removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível remover o Setor.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
    async getPermissoes(){
      this.getPermissaoPorItemPerfil("Setor.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });      
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>